import axios from 'axios';
import { REPORT_FCI_ACTION, REPORT_FCI_ENDPOINT } from './ReportFCIConstants';
import { NETWORK } from '../../App/AppConstants';
import { inIframe } from '../../App/AppUtils';

/**
 * POST information about a client side FCI (Failed Customer Interaction). This
 * method does not need to return any data to continue.
 */
export const reportFCI = () => {
    return (dispatch, getState) => {
        const { serverData = {}, fci } = getState();
        const { _csrf = '', errorModel = {} } = serverData;
        const fciPayload = {
            ...errorModel,
            is_iframe: inIframe()
        };
        axios.request({
            method: 'POST',
            url: REPORT_FCI_ENDPOINT,
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data: fciPayload
        });

        return dispatch({
            type: REPORT_FCI_ACTION,
            payload: fciPayload
        });
    };
};
